import { useTranslation } from 'react-i18next';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import CookieBanner from '../../components/feature/CookieBanner';

export default function ContactPage() {
  const { t } = useTranslation('contact');

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <CookieBanner />

      <section className="pt-32 pb-36 bg-gradient-to-b from-[#F2F4F5] to-white">
        <div className="max-w-[1080px] mx-auto px-10">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-32">
            <div>
              <h1
                className="text-5xl font-bold text-[#0A2D50] mb-6"
                style={{ fontFamily: 'Playfair Display, serif' }}
              >
                {t('title')}
              </h1>
              <h2 className="text-base font-medium text-[#0A2D50] mb-4 max-w-[420px]">
                {t('routingNotice')}
              </h2>
              <p className="text-[15px] text-gray-600 leading-relaxed">
                {t('routingText')}
              </p>
            </div>

            <div className="bg-white p-10 rounded-2xl shadow-sm border border-[#F2F4F5]">
              <div className="space-y-8">
                <div>
                  <div className="text-xs uppercase text-gray-500 mb-2 tracking-wide">
                    {t('email')}
                  </div>
                  <a
                    href="mailto:info@group-dr.com"
                    className="text-lg font-semibold text-[#1BCDFF] hover:text-[#1EB7EC] transition-colors cursor-pointer hover:underline"
                  >
                    info@group-dr.com
                  </a>
                </div>

                <div>
                  <div className="text-xs uppercase text-gray-500 mb-2 tracking-wide">
                    {t('phone')}
                  </div>
                  <a
                    href="tel:+491708843942"
                    className="text-base text-[#1BCDFF] hover:text-[#1EB7EC] transition-colors cursor-pointer hover:underline"
                  >
                    +49 170 8843 942
                  </a>
                </div>

                <div>
                  <div className="text-xs uppercase text-gray-500 mb-2 tracking-wide">
                    {t('address')}
                  </div>
                  <p className="text-[15px] text-gray-700 leading-relaxed">
                    DR Group GmbH<br />
                    In der Gottesau 4<br />
                    76646 Bruchsal<br />
                    Germany
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}